<template>
    <div>
        <div v-if="showRichTable" class="row action-bar">
            <div class="col col-8" v-if="enableSearch">
                <div class="input-group filter-input">
                    <span class="input-group-text" id="basic-addon3"><b-icon icon="search" /></span>
                    <input
                        class="form-control"
                        v-model="filter.q"
                        :debounce="debounce"
                        :placeholder="$t('overview.suppliers.table.search.placeholder')" />
                </div>
            </div>

            <div v-if="enableSort && sortOptions && sortOptions.length" class="col col-4 text-end">
                <div class="dropdown d-inline">
                    <button class="btn btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                        <small>
                            <span class="text-muted">{{ $t("ordering.label") }}: </span>
                            <span class="bold">{{ selectedSortOption.text }}</span>
                        </small>
                        <AnimatedCaret :expanded="orderingExpanded" class="ms-1"/>
                    </button>
                    <ul class="dropdown-menu">
                        <li
                            v-for="(n, i) in sortOptions"
                            class="dropdown-link"
                            :key="'opt-sort-' + i"
                            :active="selectedSortOptionValue == i"
                            @click="selectedSortOptionValue = i"
                        >
                            <span class="dropdown-item">{{ n.text }}</span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-12 mt-3">
                <div class="row">
                    <template v-for="year in years" :key="year.year">
                        <div class="form-check col-6 col-md-4 col-xl-3">
                            <input class="form-check-input" v-model="filter.years" type="checkbox" :value="year.year" :id="`year_check_${year.year}`">
                            <label class="form-check-label" :for="`year_check_${year.year}`">
                                <span v-if="year.year">{{ year.year }} ({{ $filters.price(year.amount) }})</span>
                                <span v-else>n/a ({{ $filters.price(year.amount) }})</span>
                            </label>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <Table
            :columns="settings.fields"
            :itemsDataProvider="settings.items"
            :filter="filter"
            ref="data_table" :sort-by="selectedSortOption.value.by"
            @update:sort-by="selectedSortOption.value.by = $event" :sort-desc="selectedSortOption.value.desc"
            @update:sort-desc="selectedSortOption.value.desc = $event" :enable-pagination="enablePagination"
            :enable-total-rows="enableTotalRows" :show-rich-table="showRichTable" v-on="$listeners">
            <template v-for="(_, nameComp) in $slots" v-slot:[nameComp]="data">
                <slot :name="nameComp" v-bind="data"/>
            </template>
        </Table>
    </div>
</template>

<script>
import Table from "@/components/Table.vue";
import formattersMixin from "@/plugins/formattersMixin.js";
import AnimatedCaret from "@/components/AnimatedCaret.vue";

export default {
    props: {
        tableSettings: { type: Object, required: true },
        debounce: { type: Number, required: false, default: 700 },
        onShowRowDetail: { type: Function, required: false },
        sortOptions: { type: Array, required: false, default: () => [] },
        enableSearch: { type: Boolean, default: true },
        enableSort: { type: Boolean, default: true },
        enablePagination: { type: Boolean, default: true },
        enableTotalRows: { type: Boolean, default: true },
        hash: { type: String, required: true },
        version: { type: String, required: true },
        type: { required: true },
        typeId: { required: true },
    },
    components: { Table, AnimatedCaret },
    mixins: [formattersMixin],
    data: function () {
        return {
            isBusy: false,
            filter: {
                q: null,
                years: []
            },
            orderingExpanded: false,
            selectedSortOptionValue: 0,
            showRichTable: true,
            years: []
        };
    },
    created: function () {
        this.getYears();
    },
    computed: {
        selectedSortOption: function () {
            return this.sortOptions.length
                ? this.sortOptions[this.selectedSortOptionValue]
                : null;
        },
        settings: function () {
            return Object.assign(this.tableSettings, {
                filter: this.filter,
                busy: this.isBusy,
            });
        }
    },
    methods: {
        refresh: function () {
            this.$refs.data_table.refresh();
        },
        setTotalRows: function (count) {
            this.$refs.data_table.setTotalRows(count);
            if (this.initialCount == null) {
                this.initialCount = count;
            }
            if (this.initialCount != null && this.initialCount < 6) {
                this.showRichTable = false;
            }

        },
        getYears: function () {
            var params = {}
            params[this.type] = this.typeId;

            params[`${this.version}_hash`] = this.hash;
            this.$store.getters.api
                .get("/get_invoices_years/", { params: params })
                .then((response) => {
                    this.years = response.data.years
                })
                .catch((e) => {
                    console.log(e)
                    this.years = []
                });
        }
    },
};
</script>

<style lang="scss" scoped>
.action-bar {
    margin-bottom: 20px;

    .ordering {
        white-space: nowrap;
        display: inline-block;
        line-height: 38px;
        vertical-align: unset;
        cursor: pointer;

        svg {
            margin-left: 10px;
        }

        &:not(:last-child) {
            margin-right: 20px;
        }

        width: 200px;
    }
}
</style>

<style lang="scss">
.filter-input {
    &.b-form-datepicker {
        label {
            line-height: 32px;
        }
    }
}

.dropdown {
    .dropdown-toggle {
        padding: 0;
        background-color: transparent;
        border: none;
        vertical-align: unset;

        &:hover {
            background-color: transparent;
        }
    }
}
</style>
